import HeaderPageExtension from '../../components/HeaderPageExtension';
import MainContainerShowExtension from '../../components/MainContainerShowExtension';

function PageDownloadExtension(props) {
    const {
        statusMode,
        setStatusMode,
        isLoggedIn,
        showLogoutButton,
        notificationVolume,
        setNotificationVolume,
        userData,
    } = props;


    return (
        <>
            {
                isLoggedIn === true ?
                    <>
                        <HeaderPageExtension
                            statusMode={statusMode}
                            setStatusMode={setStatusMode}
                            isLoggedIn={isLoggedIn}
                            showLogoutButton={showLogoutButton}
                            notificationVolume={notificationVolume}
                            setNotificationVolume={setNotificationVolume}
                            userData={userData}
                            user={userData}
                        />
                        <MainContainerShowExtension />
                    </>
                    :
                    ""
            }
        </>
    );
}


export default PageDownloadExtension;